export default [
    {
        path: 'relatorio-cadastro-consistente',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cadastro-consistente' */
            '@/views/atencao-basica/relatorio-cadastro-consistente/Index'
        ),
        redirect: 'relatorio-cadastro-consistente/index',
        children: [
            {
                name: 'atencao-basica-relatorio-cadastro-consistente-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-cadastro-consistente' */
                    '@/views/atencao-basica/relatorio-cadastro-consistente/List.vue'
                ),
            },
        ],
    },
]
